module.exports = __webpack_public_path__ + "static/media/local-18@2x.8a2f96ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-18@2x.png
// module id = 1183
// module chunks = 2